import { render, staticRenderFns } from "./ApproverManagement.vue?vue&type=template&id=fbeb2f20&scoped=true"
import script from "./ApproverManagement.vue?vue&type=script&lang=js"
export * from "./ApproverManagement.vue?vue&type=script&lang=js"
import style0 from "./ApproverManagement.vue?vue&type=style&index=0&id=fbeb2f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbeb2f20",
  null
  
)

export default component.exports